import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c6ce3ae8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c6ce3ae8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ce3ae8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6ce3ae8')) {
      api.createRecord('c6ce3ae8', component.options)
    } else {
      api.reload('c6ce3ae8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c6ce3ae8&scoped=true", function () {
      api.rerender('c6ce3ae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/FormEditPage/index.vue"
export default component.exports